import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDTn5g4kWsicizTn5WIHAHMB-LwhpmWfd4",
  authDomain: "clone1-f2dd7.firebaseapp.com",
  databaseURL: "https://clone1-f2dd7.firebaseio.com",
  projectId: "clone1-f2dd7",
  storageBucket: "clone1-f2dd7.appspot.com",
  messagingSenderId: "62177218790",
  appId: "1:62177218790:web:72ad87b4904eec2ab22b27",
  measurementId: "G-Y41D4BPL93",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
